import { RestClient } from '@atlassian/ptc-common';

/**
 * REST Client to make calls to resources on the current site (e.g. Jira or Confluence).
 *
 * Redirects to the instance login screen when a response returns a 401.
 *
 * @type {RestClient}
 */

const defaultConfig = {
	serviceUrl: '',
};

class SiteClient extends RestClient {
	constructor(config = {}) {
		super({ ...defaultConfig, ...config });
	}

	async getDefaultCloudIDFromAvailableProducts(): Promise<string | undefined> {
		try {
			const response = await this.getResource<AvailableProductsResponse>(
				'/gateway/api/app-switcher/api/available-products',
			);
			// Filter the sites to find the first one with a cloudId
			return response.sites?.filter((site) => site.cloudId)?.[0]?.cloudId;
		} catch {
			return undefined;
		}
	}

	async getEdgeTenantInfo(): Promise<{ cloudId?: string }> {
		// @ts-ignore TS2339
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return this.getResource<{ cloudId?: string }>('/_edge/tenant_info');
	}
}

export default new SiteClient();

export interface AvailableSite {
	cloudId?: string;
}

export interface AvailableLink {
	linkType: string;
	url: string;
}

export interface AvailableProductsResponse {
	sites: AvailableSite[];
}
